
// MWC Recommendation Admin - Review queue step 1
// Loads watches that still need recommendations.
// Next step: load candidates for selected watch.

(function () {
  if (!window.mwcCandidateTagInfoHandlerInstalled) {
    window.mwcCandidateTagInfoHandlerInstalled = true;

    document.addEventListener("click", async function (event) {
      var button = event.target.closest("[data-mwc-candidate-tag-info]");

      if (!button) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      function escapeTagInfoHtml(value) {
        return String(value == null ? "" : value)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#039;");
      }

      function getTagInfoValue(tags, key) {
        var colonPrefix = "mwc_" + String(key || "").toLowerCase() + ":";
        var underscorePrefix = "mwc_" + String(key || "").toLowerCase() + "_";

        for (var i = 0; i < (tags || []).length; i += 1) {
          var text = String(tags[i] || "").trim();
          var normalizedText = text.toLowerCase();
          var value = "";

          if (normalizedText.indexOf(colonPrefix) === 0) {
            value = text.slice(text.indexOf(":") + 1);
          } else if (normalizedText.indexOf(underscorePrefix) === 0) {
            value = text.slice(underscorePrefix.length);
          } else {
            continue;
          }

          value = value.split(",")[0].trim();

          if (value) {
            return value;
          }
        }

        return "";
      }

      var handle = button.getAttribute("data-handle") || "";
      var card = button.closest("[data-mwc-candidate-card]");
      var buttonWrap = button.parentElement;
      var existingPanel = card ? card.querySelector("[data-mwc-candidate-tag-info-panel]") : null;

      if (!handle || !card || !buttonWrap) {
        return;
      }

      if (existingPanel) {
        existingPanel.remove();
        button.textContent = "Tag info";
        return;
      }

      var panel = document.createElement("div");
      panel.setAttribute("data-mwc-candidate-tag-info-panel", "true");
      panel.className = "text-xs text-subdued";
      panel.style.border = "1px solid rgb(var(--border-color))";
      panel.style.padding = "8px";
      panel.style.marginTop = "6px";
      panel.style.background = "rgb(var(--background))";
      panel.textContent = "Loading tag info...";
      buttonWrap.insertAdjacentElement("afterend", panel);

      button.disabled = true;
      button.textContent = "Loading...";

      try {
        var response = await fetch(
          "https://dev-edge.bulangandsons.org/mwc-admin/shopify-product-options-preview?handle=" +
            encodeURIComponent(handle),
          {
            method: "GET",
            credentials: "include"
          }
        );
        var data = await response.json();

        if (!response.ok || !data.success || !data.product) {
          throw new Error(data.error || "Product not found");
        }

        var tags = data.product.tags || [];
        var mwcTags = tags.filter(function (tag) {
          return String(tag || "").toLowerCase().indexOf("mwc_") === 0;
        });
        var missingTags = [];

        if (!getTagInfoValue(tags, "Color")) {
          missingTags.push("MWC_Color");
        }

        if (!getTagInfoValue(tags, "Material")) {
          missingTags.push("MWC_Material");
        }

        if (!getTagInfoValue(tags, "Straptype")) {
          missingTags.push("MWC_Straptype");
        }

        panel.innerHTML =
          "<div><strong>" + escapeTagInfoHtml(data.product.title || handle) + "</strong></div>" +
          "<div style='margin-top:4px;'>MWC tags: " +
          escapeTagInfoHtml(mwcTags.length ? mwcTags.join(", ") : "none") +
          "</div>" +
          (
            missingTags.length
              ? "<div style='margin-top:4px;color:#b42318;'>Missing: " +
                escapeTagInfoHtml(missingTags.join(", ")) +
                ". Fallback uses synced/title-derived values.</div>"
              : ""
          );

        button.textContent = "Hide tag info";
        button.style.borderColor = missingTags.length ? "#b42318" : "";
        button.style.color = missingTags.length ? "#b42318" : "";
      } catch (error) {
        panel.textContent =
          "Could not load tag info: " + String(error.message || error);
        button.textContent = "Tag info";
      } finally {
        button.disabled = false;
      }
    }, true);
  }

  if (!window.mwcShopifyStrapSyncHandlerInstalled) {
    window.mwcShopifyStrapSyncHandlerInstalled = true;

    document.addEventListener("click", async function (event) {
      var button = event.target.closest("[data-mwc-sync-shopify-straps]");

      if (!button) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      var statusEl = document.querySelector("[data-mwc-admin-status]");

      function setStatus(message) {
        if (statusEl) {
          statusEl.textContent = message;
        }
      }

      if (window.mwcShopifyStrapSyncInFlight) {
        setStatus("Shopify sync is already running. Please wait.");
        return;
      }

      window.mwcShopifyStrapSyncInFlight = true;
      button.disabled = true;
      button.textContent = "Syncing...";
      button.setAttribute("aria-busy", "true");
      setStatus("Refreshing Shopify strap data...");

      try {
        var response = await fetch(
          "https://dev-edge.bulangandsons.org/mwc-admin/sync-shopify-straps?dry_run=0&shop=NL",
          {
            method: "POST",
            credentials: "include"
          }
        );
        var text = await response.text();
        var data = {};

        try {
          data = JSON.parse(text);
        } catch (error) {
          throw new Error("Invalid sync response: " + text.slice(0, 200));
        }

        if (!response.ok || !data.success) {
          throw new Error(data.error || "Shopify sync failed");
        }

        var counts = data.counts || {};
        setStatus(
          "Shopify sync complete: " +
          Number(counts.products_seen || 0) +
          " products, " +
          Number(counts.importable_variants || 0) +
          " variants refreshed, " +
          Number(counts.unavailable_variants || 0) +
          " hidden/unavailable, " +
          Number(counts.stale_listings_deactivated || 0) +
          " stale deactivated, " +
          Number(counts.skipped_no_lug_width || 0) +
          " skipped without lug width."
        );
      } catch (error) {
        console.error("Failed to sync Shopify straps:", error);
        setStatus(
          "Request failed while refreshing Shopify data: " +
          String(error.message || error)
        );
      } finally {
        window.mwcShopifyStrapSyncInFlight = false;
        button.disabled = false;
        button.textContent = "Sync Shopify";
        button.removeAttribute("aria-busy");
      }
    }, true);
  }

  if (window.mwcRecommendationAdminInitialized) return;
  window.mwcRecommendationAdminInitialized = true;

  document.addEventListener("DOMContentLoaded", function () {
    var queueEl = document.querySelector("[data-mwc-review-queue]");
    var refreshQueueButton = document.querySelector("[data-mwc-refresh-queue]");
    var syncShopifyStrapsButton = document.querySelector("[data-mwc-sync-shopify-straps]");
    var selectedWatchEl = document.querySelector("[data-mwc-selected-watch]");
    var statusEl = document.querySelector("[data-mwc-admin-status]");
    var reviewControlsEl = document.querySelector("[data-mwc-review-controls]");
    var approvedCounterEl = document.querySelector("[data-mwc-approved-counter]");
    var maxRecommendationsInput = document.querySelector("[data-mwc-max-recommendations]");
    var pendingSectionEl = document.querySelector("[data-mwc-pending-section]");
    var approvedSectionEl = document.querySelector("[data-mwc-approved-section]");
    var queueFilterEl = document.querySelector("[data-mwc-queue-filter]");
    var onlyWithPhotoEl = document.querySelector("[data-mwc-only-with-photo]");
    var onlyWithLugWidthEl = document.querySelector("[data-mwc-only-with-lug-width]");
    var allQueueItems = [];
    var currentCandidatePage = 1;
    var candidateTagInfoCache = {};
    var batchSizeInput = document.querySelector("[data-mwc-batch-size]");
    var nextRecommendationsButton = document.querySelector("[data-mwc-next-recommendations]");
    var candidatesEl = document.querySelector("[data-mwc-admin-candidates]");
    var approveButton = document.querySelector("[data-mwc-approve-selected]");
    var saveSettingsButton = document.querySelector("[data-mwc-save-settings]");
    var reviewAdminView = document.querySelector("[data-mwc-review-admin-view]");
    var scoringAdminView = document.querySelector("[data-mwc-scoring-admin-view]");
    var adminViewButtons = document.querySelectorAll("[data-mwc-admin-view]");
    var scoringStatusEl = document.querySelector("[data-mwc-scoring-status]");
    var scoringRulesEl = document.querySelector("[data-mwc-scoring-rules]");
    var refreshScoringRulesButton = document.querySelector("[data-mwc-refresh-scoring-rules]");
    var addScoringRuleButton = document.querySelector("[data-mwc-add-scoring-rule]");
    var newRuleGroupInput = document.querySelector("[data-mwc-new-rule-group]");
    var newWatchAttributeInput = document.querySelector("[data-mwc-new-watch-attribute]");
    var newWatchValueInput = document.querySelector("[data-mwc-new-watch-value]");
    var newProductAttributeInput = document.querySelector("[data-mwc-new-product-attribute]");
    var newProductValueInput = document.querySelector("[data-mwc-new-product-value]");
    var newPointsInput = document.querySelector("[data-mwc-new-points]");
    var newReasonInput = document.querySelector("[data-mwc-new-reason]");
    var newActiveInput = document.querySelector("[data-mwc-new-active]");



    var scoringConfigOptions = {
      attributes: {
        rule_group: [],
        watch_attribute: [],
        product_attribute: []
      },
      values: {
        watch_attribute: {},
        product_attribute: {}
      }
    };

    var selectedWatch = null;

    if (!queueEl || !selectedWatchEl || !statusEl) {
      console.warn("MWC recommendation admin: required queue elements not found.");
      return;
    }

    function getAdminApiBase() {
      return "https://dev-edge.bulangandsons.org";
    }

    function escapeHtml(value) {
      return String(value == null ? "" : value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }

    function normalizeImageUrl(url) {
      if (!url) return "";

      if (String(url).indexOf("//") === 0) {
        return "https:" + url;
      }

      return String(url);
    }

    function normalizeRuleKey(value) {
      return String(value || "")
        .trim()
        .toLowerCase()
        .replace(/[\s-]+/g, "_");
    }

    async function fetchJson(url, options) {
      var response = await fetch(url, options || {});
      var text = await response.text();

      // console.log("MWC admin fetch response", {
      //   url: url,
      //   status: response.status,
      //   bodyPreview: text.slice(0, 500)
      // });

      if (!response.ok) {
        if (response.status === 401) {
          throw new Error(
            "Admin session expired or missing. Please log in again."
          );
        }

        if (response.status === 403) {
          throw new Error(
            "You do not have admin access for this action."
          );
        }

        throw new Error(
          "Request failed: " +
            response.status +
            " for " +
            url +
            ". See console for response preview."
        );
      }

      try {
        return JSON.parse(text);
      } catch (error) {
        throw new Error("Invalid JSON for " + url);
      }
    }

    function setAdminView(view) {
      var isScoring = view === "scoring";

      if (reviewAdminView) {
        reviewAdminView.style.display = isScoring ? "none" : "";
      }

      if (scoringAdminView) {
        scoringAdminView.style.display = isScoring ? "" : "none";
      }

      adminViewButtons.forEach(function (button) {
        var buttonView = button.getAttribute("data-mwc-admin-view");
        var isActive = buttonView === view;

        button.style.display = isActive ? "none" : "";
        button.classList.add("button--outline");
      });

      if (isScoring) {
        loadScoringConfigOptions().then(function () {
          loadScoringRules();
        });
      }
    }

    async function loadScoringConfigOptions() {
      try {
        var data = await fetchJson(
          getAdminApiBase() + "/mwc-admin/scoring-config-options",
          {
            method: "GET",
            credentials: "include"
          }
        );

        if (!data.success) {
          throw new Error(data.error || "Could not load scoring config options");
        }

        scoringConfigOptions = {
          attributes: data.attributes || {
            rule_group: [],
            watch_attribute: [],
            product_attribute: []
          },
          values: data.values || {
            watch_attribute: {},
            product_attribute: {}
          }
        };

        populateAddScoringRuleDropdowns();

        return scoringConfigOptions;
      } catch (error) {
        console.error("Failed to load scoring config options:", error);

        if (scoringStatusEl) {
          scoringStatusEl.textContent =
            "Could not load scoring config options: " + String(error.message || error);
        }

        return scoringConfigOptions;
      }
    }

    async function loadScoringRules() {
      if (!scoringRulesEl) {
        return;
      }

      if (scoringStatusEl) {
        scoringStatusEl.textContent = "Loading scoring rules...";
      }

      try {
        var data = await fetchJson(
          getAdminApiBase() + "/mwc-admin/scoring-rules",
          {
            method: "GET",
            credentials: "include"
          }
        );

        if (!data.success) {
          scoringRulesEl.innerHTML =
            "<pre style='white-space:pre-wrap;'>" +
            escapeHtml(JSON.stringify(data, null, 2)) +
            "</pre>";

          if (scoringStatusEl) {
            scoringStatusEl.textContent = "Error loading scoring rules.";
          }

          return;
        }

        renderScoringRules(data.rules || []);

        if (scoringStatusEl) {
          scoringStatusEl.textContent = "";
        }
      } catch (error) {
        console.error("Failed to load scoring rules:", error);

        if (scoringRulesEl) {
          scoringRulesEl.innerHTML =
            "<pre style='white-space:pre-wrap;'>" +
            escapeHtml(String(error.message || error)) +
            "</pre>";
        }

        if (scoringStatusEl) {
          scoringStatusEl.textContent = "Request failed while loading scoring rules.";
        }
      }
    }

    function renderScoringRules(rules) {
  if (!scoringRulesEl) {
    return;
  }

  if (!rules.length) {
    scoringRulesEl.innerHTML =
      "<div class='text-sm text-subdued'>No scoring rules found.</div>";
    return;
  }

  var groups = {};

  rules.forEach(function (rule) {
    var groupKey = [
      rule.rule_group || "",
      rule.watch_attribute || "",
      rule.product_attribute || ""
    ].join("||");

    if (!groups[groupKey]) {
      groups[groupKey] = {
        rule_group: rule.rule_group || "",
        watch_attribute: rule.watch_attribute || "",
        product_attribute: rule.product_attribute || "",
        rules: []
      };
    }

    groups[groupKey].rules.push(rule);
  });

  scoringRulesEl.innerHTML = Object.keys(groups).map(function (groupKey) {
    var group = groups[groupKey];

    var rowsHtml = group.rules.map(function (rule) {
      return `
        <tr data-mwc-scoring-rule-row data-rule-id="${escapeHtml(rule.id)}">
          <td style="padding:8px 10px;border-top:1px solid rgb(var(--border-color));vertical-align:top;text-align:left;">
            ${escapeHtml(rule.watch_value || "")}
          </td>

          <td style="padding:8px 10px;border-top:1px solid rgb(var(--border-color));vertical-align:top;text-align:left;">
            ${escapeHtml(rule.product_value || "")}
          </td>

          <td style="padding:8px 10px;border-top:1px solid rgb(var(--border-color));vertical-align:top;text-align:left;white-space:nowrap;">
            <input
              class="input"
              type="number"
              value="${escapeHtml(rule.points)}"
              data-mwc-scoring-points
              style="width:90px;"
            >
          </td>

          <td style="padding:8px 10px;border-top:1px solid rgb(var(--border-color));vertical-align:top;text-align:left;white-space:nowrap;">
            <input
              class="input"
              type="text"
              value="${escapeHtml(rule.reason_template || "")}"
              data-mwc-scoring-reason
              style="width:100%;min-width:260px;white-space:nowrap;"
            >
          </td>

          <td style="padding:8px 10px;border-top:1px solid rgb(var(--border-color));vertical-align:top;text-align:left;white-space:nowrap;">
            <select
              class="select"
              data-mwc-scoring-active
              style="min-width:110px;"
            >
              <option value="1" ${Number(rule.active) ? "selected" : ""}>Active</option>
              <option value="0" ${Number(rule.active) ? "" : "selected"}>Inactive</option>
            </select>
                </td>

                <td style="padding:8px 10px;border-top:1px solid rgb(var(--border-color));vertical-align:top;text-align:left;white-space:nowrap;">
                  <div style="display:flex;gap:8px;align-items:center;">
                  <button
                    type="button"
                    class="button button--outline"
                    data-mwc-save-scoring-rule
                    data-rule-id="${escapeHtml(rule.id)}"
                  >
                    Save
                  </button>

                  <button
                    type="button"
                    class="button button--outline"
                    data-mwc-delete-scoring-rule
                    data-rule-id="${escapeHtml(rule.id)}"
                  >
                    Delete
                  </button>
                  </div>
                </td>
        </tr>
      `;
    }).join("");

    return `
      <div style="border:1px solid rgb(var(--border-color));background:rgb(var(--background));">
        <div style="padding:12px 14px;border-bottom:1px solid rgb(var(--border-color));">
          <div class="text-sm text-subdued">
            ${escapeHtml(group.rule_group)}
          </div>

          <div class="h5" style="margin-top:2px;">
            ${escapeHtml(group.watch_attribute)}
            →
            ${escapeHtml(group.product_attribute)}
          </div>
        </div>

        <div style="overflow-x:auto;">
          <table style="width:100%;border-collapse:collapse;font-size:13px;text-align:left;">
            <thead>
              <tr>
                <th style="padding:8px 10px;text-align:left;font-weight:600;">Watch</th>
                <th style="padding:8px 10px;text-align:left;font-weight:600;">Product</th>
                <th style="padding:8px 10px;text-align:left;font-weight:600;">Points</th>
                <th style="padding:8px 10px;text-align:left;font-weight:600;">Reason</th>
                <th style="padding:8px 10px;text-align:left;font-weight:600;">Status</th>
                <th style="padding:8px 10px;text-align:left;font-weight:600;">Actions</th>
              </tr>
            </thead>

            <tbody>
              ${rowsHtml}
            </tbody>
          </table>
        </div>
      </div>
    `;
  }).join("");
}

function fillSelectOptions(selectEl, options, placeholder) {
  if (!selectEl) {
    return;
  }

  var html = "";

  if (placeholder) {
    html += '<option value="">' + escapeHtml(placeholder) + '</option>';
  }

  (options || []).forEach(function (option) {
    html +=
      '<option value="' + escapeHtml(option.value) + '">' +
      escapeHtml(option.label || option.value) +
      '</option>';
  });

  selectEl.innerHTML = html;
}

function fillDatalistOptions(inputEl, options, placeholder) {
  if (!inputEl) {
    return;
  }

  inputEl.value = "";
  inputEl.placeholder = placeholder || "";

  var listId = inputEl.getAttribute("list");
  var datalistEl = listId ? document.getElementById(listId) : null;

  if (!datalistEl) {
    return;
  }

  datalistEl.innerHTML = (options || []).map(function (option) {
    return (
      '<option value="' +
      escapeHtml(option.value) +
      '">' +
      escapeHtml(option.label || option.value) +
      "</option>"
    );
  }).join("");
}

function populateAddScoringRuleDropdowns() {
  
  fillSelectOptions(
    newWatchAttributeInput,
    scoringConfigOptions.attributes.watch_attribute,
    "Choose watch attr"
  );

  fillSelectOptions(
    newProductAttributeInput,
    scoringConfigOptions.attributes.product_attribute,
    "Choose product attr"
  );

  if (newPointsInput && newPointsInput.value === "") {
    newPointsInput.value = "0";
  }

  updateAddScoringRuleValueDropdowns();
}


function populateValueDropdown(valueEl, attributeType, attributeKey, placeholder) {
  if (!valueEl) {
    return;
  }

  if (!attributeKey) {
    if (String(valueEl.tagName || "").toLowerCase() === "input") {
      fillDatalistOptions(valueEl, [], placeholder);
    } else {
      fillSelectOptions(valueEl, [], placeholder);
    }
    return;
  }

  var options =
    scoringConfigOptions.values &&
    scoringConfigOptions.values[attributeType] &&
    scoringConfigOptions.values[attributeType][attributeKey]
      ? scoringConfigOptions.values[attributeType][attributeKey]
      : [];

  if (String(valueEl.tagName || "").toLowerCase() === "input") {
    fillDatalistOptions(
      valueEl,
      options,
      options.length ? "Choose or type value" : "Type value"
    );
    return;
  }

  fillSelectOptions(
    valueEl,
    options,
    options.length ? "Choose value" : "No configured values"
  );
}

function getConfiguredValueOptions(attributeType, attributeKey) {
  return scoringConfigOptions.values &&
    scoringConfigOptions.values[attributeType] &&
    scoringConfigOptions.values[attributeType][attributeKey]
      ? scoringConfigOptions.values[attributeType][attributeKey]
      : [];
}

function isConfiguredValue(attributeType, attributeKey, value) {
  var normalizedValue = String(value || "").trim().toLowerCase();
  var options = getConfiguredValueOptions(attributeType, attributeKey);

  if (!options.length) {
    return true;
  }

  return options.some(function (option) {
    return String(option.value || "").trim().toLowerCase() === normalizedValue;
  });
}

function setInvalidValueState(valueEl, isInvalid) {
  if (!valueEl) {
    return;
  }

  if (isInvalid) {
    valueEl.setAttribute("aria-invalid", "true");
    valueEl.style.borderColor = "#c00";
    valueEl.style.boxShadow = "0 0 0 1px #c00";
    return;
  }

  valueEl.removeAttribute("aria-invalid");
  valueEl.style.borderColor = "";
  valueEl.style.boxShadow = "";
}

function validateConfiguredValueInput(valueEl, attributeType, attributeKey, label) {
  if (!valueEl) {
    return true;
  }

  var value = String(valueEl.value || "").trim();

  if (!value || isConfiguredValue(attributeType, attributeKey, value)) {
    setInvalidValueState(valueEl, false);
    return true;
  }

  setInvalidValueState(valueEl, true);
  valueEl.focus();

  if (scoringStatusEl) {
    scoringStatusEl.textContent =
      "Choose an existing configured " + label + " value for " + attributeKey + ".";
  }

  return false;
}

function updateAddScoringRuleWatchValueDropdown() {
  setInvalidValueState(newWatchValueInput, false);

  populateValueDropdown(
    newWatchValueInput,
    "watch_attribute",
    newWatchAttributeInput ? newWatchAttributeInput.value : "",
    "Choose watch attr first"
  );
}

function validateAddScoringRuleWatchValue() {
  var watchAttribute = newWatchAttributeInput
    ? normalizeRuleKey(newWatchAttributeInput.value)
    : "";

  return validateConfiguredValueInput(
    newWatchValueInput,
    "watch_attribute",
    watchAttribute,
    "watch"
  );
}

function updateAddScoringRuleProductValueDropdown() {
  setInvalidValueState(newProductValueInput, false);

  populateValueDropdown(
    newProductValueInput,
    "product_attribute",
    newProductAttributeInput ? newProductAttributeInput.value : "",
    "Choose product attr first"
  );
}

function validateAddScoringRuleProductValue() {
  var productAttribute = newProductAttributeInput
    ? normalizeRuleKey(newProductAttributeInput.value)
    : "";

  return validateConfiguredValueInput(
    newProductValueInput,
    "product_attribute",
    productAttribute,
    "product"
  );
}

function updateAddScoringRuleValueDropdowns() {
  updateAddScoringRuleWatchValueDropdown();
  updateAddScoringRuleProductValueDropdown();
}




    function resetAddScoringRuleForm() {
      if (newWatchValueInput) {
        newWatchValueInput.value = "";
      }

      if (newProductValueInput) {
        newProductValueInput.value = "";
      }

      if (newPointsInput) {
        newPointsInput.value = "";
      }

      if (newReasonInput) {
        newReasonInput.value = "";
      }

      if (newActiveInput) {
        newActiveInput.value = "1";
      }
    }

    async function loadQueue(options) {
      options = options || {};
      queueEl.innerHTML = "<div class='text-sm text-subdued'>Loading queue...</div>";

      if (!options.preserveStatus) {
        statusEl.textContent = "Loading review queue...";
      }

      try {
        var data = await fetchJson(
          getAdminApiBase() + "/mwc-admin/recommendation-review-queue?shop=NL",
          {
            method: "GET",
            credentials: "include"
          }
        );

        if (!data.success) {
          queueEl.innerHTML =
            "<pre style='white-space:pre-wrap;'>" +
            escapeHtml(JSON.stringify(data, null, 2)) +
            "</pre>";
          statusEl.textContent = "Error loading review queue.";
          return;
        }

        allQueueItems = data.items || [];
        renderQueue(getFilteredQueueItems());

        if (!selectedWatch || !options.preserveStatus) {
          statusEl.textContent =
            "Showing " + getFilteredQueueItems().length + " watch(es).";
        }
      } catch (error) {
        queueEl.innerHTML =
          "<pre style='white-space:pre-wrap;'>" +
          escapeHtml(String(error.message || error)) +
          "</pre>";
        statusEl.textContent = "Request failed while loading queue.";
      }
    }

    async function syncShopifyStraps() {
      if (!syncShopifyStrapsButton) {
        return;
      }

      if (window.mwcShopifyStrapSyncInFlight) {
        statusEl.textContent = "Shopify sync is already running. Please wait.";
        return;
      }

      window.mwcShopifyStrapSyncInFlight = true;
      syncShopifyStrapsButton.disabled = true;
      syncShopifyStrapsButton.textContent = "Syncing...";
      syncShopifyStrapsButton.setAttribute("aria-busy", "true");
      statusEl.textContent = "Refreshing Shopify strap data...";

      try {
        var data = await fetchJson(
          getAdminApiBase() + "/mwc-admin/sync-shopify-straps?dry_run=0&shop=NL",
          {
            method: "POST",
            credentials: "include"
          }
        );

        if (!data.success) {
          statusEl.textContent = "Shopify sync failed: " + (data.error || "unknown error");
          return;
        }

        var counts = data.counts || {};
        statusEl.textContent =
          "Shopify sync complete: " +
          Number(counts.products_seen || 0) +
          " products, " +
          Number(counts.importable_variants || 0) +
          " variants refreshed, " +
          Number(counts.unavailable_variants || 0) +
          " hidden/unavailable, " +
          Number(counts.stale_listings_deactivated || 0) +
          " stale deactivated, " +
          Number(counts.skipped_no_lug_width || 0) +
          " skipped without lug width.";

        await loadQueue({ preserveStatus: true });
      } catch (error) {
        console.error("Failed to sync Shopify straps:", error);
        statusEl.textContent =
          "Request failed while refreshing Shopify data: " +
          String(error.message || error);
      } finally {
        window.mwcShopifyStrapSyncInFlight = false;
        syncShopifyStrapsButton.disabled = false;
        syncShopifyStrapsButton.textContent = "Sync Shopify";
        syncShopifyStrapsButton.removeAttribute("aria-busy");
      }
    }

    function hasKnownLugWidth(item) {
      var lugWidth = String(item && item.lug_width != null ? item.lug_width : "").trim();

      if (!lugWidth) return false;
      if (lugWidth.toLowerCase() === "unknown") return false;
      if (lugWidth.toLowerCase() === "null") return false;

      return /\d+/.test(lugWidth);
    }


    function getFilteredQueueItems() {
      var filter = queueFilterEl ? queueFilterEl.value : "needs";
      var onlyWithPhoto = onlyWithPhotoEl ? onlyWithPhotoEl.checked : true;
      var onlyWithLugWidth = onlyWithLugWidthEl ? onlyWithLugWidthEl.checked : true;

      return (allQueueItems || []).filter(function (item) {
        var approvedCount = Number(item.approved_count || 0);
        var maxRecommendations = Number(item.max_recommendations || 5);
        var remainingSlots = Math.max(0, maxRecommendations - approvedCount);
        var hasPhoto = Boolean(item.main_image_url);

        if (onlyWithPhoto && !hasPhoto) {
          return false;
        }
        if (onlyWithLugWidth && !hasKnownLugWidth(item)) {
          return false;
        }

        if (filter === "needs") {
          return approvedCount === 0;
        }

        if (filter === "approved") {
          return approvedCount > 0;
        }

        if (filter === "review") {
          return Number(item.review_issue_count || 0) > 0;
        }


        if (filter === "completed") {
          return approvedCount >= maxRecommendations;
        }

        if (filter === "all") {
          return true;
        }

        return approvedCount === 0;
      });
    }


    function renderQueue(items) {
      if (!items.length) {
        queueEl.innerHTML =
          "<div class='text-sm text-subdued'>No watches need recommendations right now.</div>";
        return;
      }

      queueEl.innerHTML = items.map(function (item) {
        var title = [item.brand, item.model, item.reference].filter(Boolean).join(" ");
        var imageUrl = normalizeImageUrl(item.main_image_url);

        return `
          <button
            type="button"
            data-mwc-queue-item="${escapeHtml(item.user_watch_id)}"
            style="width:100%;text-align:left;border:1px solid rgb(var(--border-color));padding:12px;background:rgb(var(--background));display:grid;grid-template-columns:64px minmax(0,1fr);gap:12px;align-items:center;"
          >
            <div>
              ${
                imageUrl
                  ? `
                    <img
                      src="${escapeHtml(imageUrl)}"
                      alt="${escapeHtml(title)}"
                      style="width:64px;aspect-ratio:1/1;object-fit:cover;border:1px solid rgb(var(--border-color));"
                    >
                  `
                  : `
                    <div
                      class="text-xs text-subdued"
                      style="width:64px;aspect-ratio:1/1;border:1px solid rgb(var(--border-color));display:grid;place-items:center;"
                    >
                      No image
                    </div>
                  `
              }
            </div>

            <div class="v-stack gap-1">
              <strong style="font-size:13px;line-height:1.3;">
                ${escapeHtml(title || "Untitled watch")}
              </strong>

              <div class="text-xs text-subdued">
                Approved ${escapeHtml(item.approved_count)} / ${escapeHtml(item.max_recommendations)}
              </div>

              ${
                Number(item.review_issue_count || 0) > 0
                  ? `
                    <div class="text-xs text-subdued">
                      Needs review: ${escapeHtml(item.review_issue_count)}
                    </div>
                  `
                  : ""
              }

              <div class="text-xs text-subdued">
                Remaining: ${escapeHtml(item.remaining_slots)}
              </div>
            </div>
          </button>
        `;
      }).join("");

      Array.from(document.querySelectorAll("[data-mwc-queue-item]")).forEach(function (button) {
        button.addEventListener("click", function () {
          var userWatchId = button.getAttribute("data-mwc-queue-item");
          var item = items.find(function (queueItem) {
            return String(queueItem.user_watch_id) === String(userWatchId);
          });

          if (item) {
            selectWatch(item);
          }
        });
      });
    }

    function selectWatch(item) {
      selectedWatch = item;
      currentCandidatePage = 1;
      if (candidatesEl) {
        candidatesEl.innerHTML = "";
      }

      if (approveButton) {
        approveButton.style.display = "none";
      }

      if (pendingSectionEl) {
        pendingSectionEl.style.display = "none";
      }

      var title = [item.brand, item.model, item.reference].filter(Boolean).join(" ");
      var imageUrl = normalizeImageUrl(item.main_image_url);

      selectedWatchEl.innerHTML = `
        <div class="v-stack gap-4">
          <div>
            ${
              imageUrl
                ? `
                  <img
                    src="${escapeHtml(imageUrl)}"
                    alt="${escapeHtml(title)}"
                    style="width:100%;max-width:420px;aspect-ratio:1/1;object-fit:cover;border:1px solid rgb(var(--border-color));"
                  >
                `
                : ""
            }
          </div>

          <div class="v-stack gap-2">
            <h2 class="h4">${escapeHtml(title || "Selected watch")}</h2>

            <div class="text-sm text-subdued">
              User watch ID: ${escapeHtml(item.user_watch_id)}
            </div>

            <div class="text-sm">
              Lug width: ${escapeHtml(item.lug_width || "Unknown")}
              · Dial: ${escapeHtml(item.dial_color || "Unknown")}
              · Case: ${escapeHtml(item.case_material || "Unknown")}
            </div>

          </div>
        </div>
      `;

      if (reviewControlsEl) {
        reviewControlsEl.style.display = "";
      }
      
      if (approvedSectionEl) {
        approvedSectionEl.style.display = "";
      }

      if (approvedCounterEl) {
        approvedCounterEl.textContent =
          "Approved " +
          item.approved_count +
          " / " +
          item.max_recommendations +
          " · Remaining slots: " +
          item.remaining_slots;
      }

      if (maxRecommendationsInput) {
        maxRecommendationsInput.value = item.max_recommendations || 5;
      }

      if (nextRecommendationsButton) {
        nextRecommendationsButton.disabled = Number(item.remaining_slots || 0) <= 0;
      }

      statusEl.textContent = "";
      loadApprovedRecommendations();
    }

    async function loadNextRecommendations() {
      return loadCandidatePage(1, { regenerate: true });
    }

    async function generateRecommendationCandidates() {
      return fetchJson(
        getAdminApiBase() +
          "/mwc-admin/generate-recommendation-candidates?user_watch_id=" +
          encodeURIComponent(selectedWatch.user_watch_id) +
          "&shop=NL",
        {
          method: "POST",
          credentials: "include"
        }
      );
    }

    async function loadCandidatePage(page, options) {
      if (!selectedWatch) {
        statusEl.textContent = "Select a watch first.";
        return;
      }

      if (!candidatesEl) return;

      var lugWidth = String(selectedWatch.lug_width || "").trim();

      if (!lugWidth || lugWidth.toLowerCase() === "unknown") {
        var message =
          "No recommendations can be generated until the lug width is known.";

        statusEl.textContent = message;
        candidatesEl.innerHTML =
          "<div class='text-sm text-subdued'>" +
          escapeHtml(message) +
          "</div>";

        if (approveButton) {
          approveButton.style.display = "none";
        }

        return;
      }

      var pageSize = batchSizeInput ? Number(batchSizeInput.value || 5) : 5;
      pageSize = Math.min(Math.max(pageSize, 1), 10);
      currentCandidatePage = Math.max(1, Number(page || 1) || 1);

      statusEl.textContent = "Loading recommendations...";
      candidatesEl.innerHTML = "";
      if (approveButton) approveButton.style.display = "none";

      if (pendingSectionEl) {
        pendingSectionEl.style.display = "";
      }

      try {
        if (options && options.regenerate) {
          statusEl.textContent = "Refreshing recommendations...";

          var refreshedData = await generateRecommendationCandidates();

          if (!refreshedData.success) {
            candidatesEl.innerHTML =
              "<pre style='white-space:pre-wrap;'>" +
              escapeHtml(JSON.stringify(refreshedData, null, 2)) +
              "</pre>";
            statusEl.textContent = "Could not refresh candidates.";
            return;
          }
        }

        var url =
          getAdminApiBase() +
          "/mwc-admin/recommendation-candidates?user_watch_id=" +
          encodeURIComponent(selectedWatch.user_watch_id) +
          "&shop=NL&status=pending&page=" +
          encodeURIComponent(currentCandidatePage) +
          "&page_size=" +
          encodeURIComponent(pageSize);
        var data = await fetchJson(url, {
          method: "GET",
          credentials: "include"
        });

        if (!data.success) {
          candidatesEl.innerHTML =
            "<pre style='white-space:pre-wrap;'>" +
            escapeHtml(JSON.stringify(data, null, 2)) +
            "</pre>";
          statusEl.textContent = "Error loading recommendations.";
          return;
        }

        if (Number(data.total || 0) === 0) {
          statusEl.textContent = "No candidates found yet. Generating candidates...";

          var generateData = await generateRecommendationCandidates();

          if (!generateData.success) {
            candidatesEl.innerHTML =
              "<pre style='white-space:pre-wrap;'>" +
              escapeHtml(JSON.stringify(generateData, null, 2)) +
              "</pre>";
            statusEl.textContent = "Could not generate candidates.";
            return;
          }

          statusEl.textContent =
            "Generated " +
            Number(generateData.candidates_generated || 0) +
            " candidate(s). Loading recommendations...";

          data = await fetchJson(url, {
            method: "GET",
            credentials: "include"
          });
        }

        renderCandidates(data.candidates || []);
        renderCandidatePagination(data);

        statusEl.textContent =
          "Loaded page " +
          Number(data.page || currentCandidatePage) +
          " of " +
          Number(data.total_pages || 1) +
          " · " +
          Number(data.total || 0) +
          " total candidate(s).";
      } catch (error) {
        candidatesEl.innerHTML =
          "<pre style='white-space:pre-wrap;'>" +
          escapeHtml(String(error.message || error)) +
          "</pre>";
        statusEl.textContent = "Request failed while loading recommendations.";
      }
    }


function getCandidateDbMissingTags(product) {
  var tags = product && product.mwc_missing_tags;

  if (Array.isArray(tags)) {
    return tags.filter(function (tag) {
      return String(tag || "").trim();
    });
  }

  if (typeof tags === "string" && tags.trim()) {
    try {
      var parsed = JSON.parse(tags);

      if (Array.isArray(parsed)) {
        return parsed.filter(function (tag) {
          return String(tag || "").trim();
        });
      }
    } catch (error) {
      return tags.split(",").filter(function (tag) {
        return String(tag || "").trim();
      });
    }
  }

  return [];
}

    function renderCandidates(candidates) {
  if (!candidatesEl) return;

  if (!candidates.length) {
    candidatesEl.innerHTML =
      "<div class='text-sm text-subdued'>No more new recommendations available. Try generating candidates first or select another watch.</div>";
    if (approveButton) approveButton.style.display = "none";
    return;
  }

  candidatesEl.innerHTML = candidates.map(function (candidate) {
    var title = candidate.product && candidate.product.title_base;
    var product = candidate.product || {};
    var listing = candidate.listing || {};
    var reasons = Array.isArray(candidate.match_reason) ? candidate.match_reason : [];
    var imageUrl = normalizeImageUrl(listing.image_url);
    var dbMissingTags = getCandidateDbMissingTags(product);
    var tagInfoStyle = dbMissingTags.length
      ? "font-size:12px;padding:6px 10px;min-height:0;border-color:#b42318;color:#b42318;"
      : "font-size:12px;padding:6px 10px;min-height:0;";
    var tagInfoTitle = dbMissingTags.length
      ? "Missing " + dbMissingTags.join(", ")
      : "All MWC tags present at last sync";
    // console.log("MWC candidate image", {
    //   candidate_id: candidate.candidate_id,
    //   title: title,
    //   image_url: listing.image_url,
    //   normalized_image_url: imageUrl
    // });

    return `
      <div
        data-mwc-candidate-card
        style="border:1px solid rgb(var(--border-color));padding:16px;display:block;"
      >
        <label class="h-stack align-center" style="gap:12px;margin-bottom:12px;">
          <input
            type="checkbox"
            data-mwc-candidate-checkbox
            value="${escapeHtml(candidate.candidate_id)}"
          >
          <strong>Select</strong>
        </label>

        <div style="display:grid;grid-template-columns:96px minmax(0,1fr);gap:16px;align-items:start;">
          <div>
            ${
              imageUrl
                ? `
                  <img
                    src="${String(imageUrl).replace(/"/g, "&quot;")}"
                    alt="${escapeHtml(title)}"
                    loading="lazy"
                    style="width:96px;height:96px;min-width:96px;object-fit:cover;border:1px solid rgb(var(--border-color));display:block;background:#fff;"
                  >
                `
                : `
                  <div
                    style="width:96px;height:96px;min-width:96px;border:1px solid rgb(var(--border-color));display:grid;place-items:center;background:#fff;"
                    class="text-xs text-subdued"
                  >
                    No image
                  </div>
                `
            }
          </div>

          <div class="v-stack gap-2">
            <div>
              <strong>${escapeHtml(title || "Recommendation")}</strong>
            </div>

            <div class="text-sm text-subdued">
              Candidate ID: ${escapeHtml(candidate.candidate_id)}
              · Score: ${escapeHtml(candidate.match_score)}
              · Variant: ${escapeHtml(listing.variant_title || "")}
            </div>

            <div class="text-sm">
              ${
                reasons.length
                  ? reasons.map(function (reason) {
                      return "<div>• " + escapeHtml(reason) + "</div>";
                    }).join("")
                  : ""
              }
            </div>

            <div>
              <button
                type="button"
                class="button button--outline"
                data-mwc-candidate-tag-info
                data-handle="${escapeHtml(listing.handle || "")}"
                data-color="${escapeHtml(product.strap_color || "")}"
                data-material="${escapeHtml(product.strap_material || "")}"
                data-straptype="${escapeHtml(product.proposed_strap_style || "")}"
                data-mwc-missing-tags="${escapeHtml(JSON.stringify(dbMissingTags))}"
                data-mwc-tag-status="${dbMissingTags.length ? "missing" : "complete"}"
                title="${escapeHtml(tagInfoTitle)}"
                style="${tagInfoStyle}"
              >
                Tag info
              </button>
            </div>

            <div class="text-xs text-subdued">
              Handle: ${escapeHtml(listing.handle || "")}
              · Shopify variant: ${escapeHtml(listing.shopify_variant_id || "")}
              · Price: ${escapeHtml(listing.price || "")} ${escapeHtml(listing.currency || "")}
            </div>
          </div>
        </div>
      </div>
    `;
  }).join("");

  if (approveButton) {
    approveButton.style.display = "";
  }

  refreshCandidateTagButtonStates();
}

async function getCandidateTagInfo(handle) {
  if (!handle) {
    return null;
  }

  if (candidateTagInfoCache[handle]) {
    return candidateTagInfoCache[handle];
  }

  var data = await fetchJson(
    getAdminApiBase() +
      "/mwc-admin/shopify-product-options-preview?handle=" +
      encodeURIComponent(handle),
    {
      method: "GET",
      credentials: "include"
    }
  );

  if (!data.success || !data.product) {
    throw new Error(data.error || "Product not found");
  }

  var tags = data.product.tags || [];
  var missingTags = [];

  if (!getMwcTagValue(tags, "Color")) {
    missingTags.push("MWC_Color");
  }

  if (!getMwcTagValue(tags, "Material")) {
    missingTags.push("MWC_Material");
  }

  if (!getMwcTagValue(tags, "Straptype")) {
    missingTags.push("MWC_Straptype");
  }

  candidateTagInfoCache[handle] = {
    product: data.product,
    tags: tags,
    missingTags: missingTags
  };

  return candidateTagInfoCache[handle];
}

async function refreshCandidateTagButtonStates() {
  if (!candidatesEl) return;

  var buttons = Array.from(
    candidatesEl.querySelectorAll("[data-mwc-candidate-tag-info]")
  );

  buttons.forEach(async function (button) {
    var handle = button.getAttribute("data-handle") || "";

    if (!handle) {
      return;
    }

    try {
      var info = await getCandidateTagInfo(handle);
      var missingTags = info ? info.missingTags || [] : [];

      button.style.borderColor = missingTags.length ? "#b42318" : "";
      button.style.color = missingTags.length ? "#b42318" : "";
      button.title = missingTags.length
        ? "Missing " + missingTags.join(", ")
        : "All MWC tags present";
      button.setAttribute(
        "data-mwc-tag-status",
        missingTags.length ? "missing" : "complete"
      );
    } catch (error) {
      button.title = "Could not check Shopify tags";
    }
  });
}

function normalizeTagSnakeValue(value) {
  var normalized = String(value || "")
    .trim()
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

  return normalized || "";
}

function renderCandidatePagination(data) {
  if (!candidatesEl) return;

  var totalPages = Number(data.total_pages || 1);

  if (totalPages <= 1) {
    return;
  }

  var currentPage = Number(data.page || currentCandidatePage || 1);
  var html = "<div style='display:flex;gap:6px;align-items:center;flex-wrap:wrap;margin-top:4px;' class='text-xs text-subdued'>";
  html += "<span>Pages</span>";

  for (var page = 1; page <= totalPages; page += 1) {
    html +=
      "<button type='button' class='button button--outline' data-mwc-candidate-page='" +
      escapeHtml(page) +
      "' style='font-size:12px;padding:4px 8px;min-height:0;" +
      (page === currentPage ? "border-color:currentColor;font-weight:600;" : "") +
      "'>" +
      escapeHtml(page) +
      "</button>";
  }

  html += "</div>";
  candidatesEl.insertAdjacentHTML("beforeend", html);
}

function normalizeTagMaterialValue(value) {
  var normalized = String(value || "")
    .trim()
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[_-]+/g, " ")
    .replace(/[^a-z0-9]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  return normalized || "";
}

function getMwcTagValue(tags, key) {
  var colonPrefix = "mwc_" + String(key || "").toLowerCase() + ":";
  var underscorePrefix = "mwc_" + String(key || "").toLowerCase() + "_";

  for (var i = 0; i < (tags || []).length; i += 1) {
    var text = String(tags[i] || "").trim();
    var normalizedText = text.toLowerCase();
    var value = "";

    if (normalizedText.indexOf(colonPrefix) === 0) {
      value = text.slice(text.indexOf(":") + 1);
    } else if (normalizedText.indexOf(underscorePrefix) === 0) {
      value = text.slice(underscorePrefix.length);
    } else {
      continue;
    }

    value = value.split(",")[0].trim();

    if (value) {
      return value;
    }
  }

  return "";
}

async function loadCandidateTagInfo(button) {
  var handle = button.getAttribute("data-handle") || "";
  var card = button.closest("[data-mwc-candidate-card]");
  var existingPanel = card ? card.querySelector("[data-mwc-candidate-tag-info-panel]") : null;
  var buttonWrap = button.parentElement;

  if (!handle || !card || !buttonWrap) {
    return;
  }

  if (existingPanel) {
    existingPanel.remove();
    button.textContent = "Tag info";
    return;
  }

  var panel = document.createElement("div");
  panel.setAttribute("data-mwc-candidate-tag-info-panel", "true");
  panel.className = "text-xs text-subdued";
  panel.style.border = "1px solid rgb(var(--border-color))";
  panel.style.padding = "8px";
  panel.style.marginTop = "6px";
  panel.style.background = "rgb(var(--background))";
  panel.textContent = "Loading tag info...";
  buttonWrap.insertAdjacentElement("afterend", panel);

  button.disabled = true;
  button.textContent = "Loading...";

  try {
    var info = await getCandidateTagInfo(handle);
    var productData = info ? info.product : null;
    var tags = info ? info.tags || [] : [];
    var mwcTags = tags.filter(function (tag) {
      return String(tag || "").toLowerCase().indexOf("mwc_") === 0;
    });
    var missingTags = info ? info.missingTags || [] : [];

    panel.innerHTML =
      "<div><strong>" + escapeHtml(productData && productData.title || handle) + "</strong></div>" +
      "<div style='margin-top:4px;'>MWC tags: " +
      escapeHtml(mwcTags.length ? mwcTags.join(", ") : "none") +
      "</div>" +
      (
        missingTags.length
          ? "<div style='margin-top:4px;color:#b42318;'>Missing: " +
            escapeHtml(missingTags.join(", ")) +
            ". Fallback uses synced/title-derived values.</div>"
          : ""
      );
    button.textContent = "Hide tag info";
    button.style.borderColor = missingTags.length ? "#b42318" : "";
    button.style.color = missingTags.length ? "#b42318" : "";
  } catch (error) {
    panel.textContent =
      "Could not load tag info: " + String(error.message || error);
    button.textContent = "Tag info";
  } finally {
    button.disabled = false;
  }
}

async function loadApprovedRecommendations() {
  if (!selectedWatch) return;

  var approvedEl = document.querySelector("[data-mwc-admin-approved]");
  if (!approvedEl) return;

  approvedEl.innerHTML = "<div class='text-sm text-subdued'>Loading approved recommendations...</div>";

  try {
    var data = await fetchJson(
      getAdminApiBase() +
        "/mwc-admin/approved-recommendations-list?user_watch_id=" +
        encodeURIComponent(selectedWatch.user_watch_id) +
        "&shop=NL",
      {
        method: "GET",
        credentials: "include"
      }
    );

    if (!data.success || !data.approved || !data.approved.length) {
      approvedEl.innerHTML =
        "<div class='text-sm text-subdued'>No approved recommendations yet.</div>";
      return;
    }

    approvedEl.innerHTML = data.approved.map(function (approved) {
      var title =
        approved.product && approved.product.title_base
          ? approved.product.title_base
          : "Approved recommendation";

      var listing = approved.listing || {};
      var imageUrl = normalizeImageUrl(listing.image_url);

      var status = approved.status || "active";
      var statusLabel = "";
      var customerVisibilityLabel = "";
      var reapproveButton = "";

      if (status === "needs_review") {
        statusLabel = "<span style='font-size:12px;padding:2px 6px;border:1px solid rgb(var(--border-color));display:inline-block;'>Needs review</span>";
        reapproveButton =
          "<button type='button' class='button button--outline' data-mwc-reapprove-approved='" +
          escapeHtml(approved.approved_recommendation_id) +
          "' style='padding:6px 10px;font-size:12px;'>Approve again</button>";
      } else if (status === "suspended") {
        statusLabel = "<span style='font-size:12px;padding:2px 6px;border:1px solid rgb(var(--border-color));display:inline-block;'>Suspended</span>";
        reapproveButton =
          "<button type='button' class='button button--outline' data-mwc-reapprove-approved='" +
          escapeHtml(approved.approved_recommendation_id) +
          "' style='padding:6px 10px;font-size:12px;'>Approve again</button>";
      }

      if (listing.status && listing.status !== "active") {
        customerVisibilityLabel = "<span style='font-size:12px;padding:2px 6px;border:1px solid rgb(var(--border-color));display:inline-block;background:#fff7ed;color:#9a3412;'>Hidden from customers: inactive Shopify listing</span>";
      } else if (Number(listing.available || 0) !== 1) {
        customerVisibilityLabel = "<span style='font-size:12px;padding:2px 6px;border:1px solid rgb(var(--border-color));display:inline-block;background:#fff7ed;color:#9a3412;'>Hidden from customers: stock 0</span>";
      }

      return `
        <div
          style="border:1px solid rgb(var(--border-color));padding:10px;display:grid;grid-template-columns:52px minmax(0,1fr) auto;gap:12px;align-items:center;background:rgb(var(--background-secondary));"
          data-mwc-approved-item="${escapeHtml(approved.approved_recommendation_id)}"
        >
          <div>
            ${
              imageUrl
                ? `
                  <img
                    src="${String(imageUrl).replace(/"/g, "&quot;")}"
                    alt="${escapeHtml(title)}"
                    loading="lazy"
                    style="width:52px;height:52px;object-fit:cover;border:1px solid rgb(var(--border-color));display:block;background:#fff;"
                  >
                `
                : `
                  <div
                    class="text-xs text-subdued"
                    style="width:52px;height:52px;border:1px solid rgb(var(--border-color));display:grid;place-items:center;background:#fff;"
                  >
                    No image
                  </div>
                `
            }
          </div>

          <div class="v-stack gap-1">
            <strong style="font-size:13px;line-height:1.3;">
              ${escapeHtml(title)}
            </strong>
            ${statusLabel}
            ${customerVisibilityLabel}
          </div>

          <div style="display:flex;gap:8px;align-items:center;">
  ${reapproveButton}

          <button
            type="button"
            class="button button--outline"
            data-mwc-remove-approved="${escapeHtml(approved.approved_recommendation_id)}"
            style="padding:6px 10px;font-size:12px;"
          >
            Remove
          </button>
        </div>
        </div>
      `;
    }).join("");
    Array.from(document.querySelectorAll("[data-mwc-remove-approved]")).forEach(function (button) {
      button.addEventListener("click", function () {
        var approvedRecommendationId = button.getAttribute("data-mwc-remove-approved");
        removeApprovedRecommendation(approvedRecommendationId);
      });
    });

    Array.from(document.querySelectorAll("[data-mwc-reapprove-approved]")).forEach(function (button) {
      button.addEventListener("click", function () {
        var approvedRecommendationId = button.getAttribute("data-mwc-reapprove-approved");
        reapproveApprovedRecommendation(approvedRecommendationId);
      });
    });



  } catch (error) {
    approvedEl.innerHTML =
      "<pre style='white-space:pre-wrap;'>" +
      escapeHtml(String(error.message || error)) +
      "</pre>";
  }
}

async function reapproveApprovedRecommendation(approvedRecommendationId) {
  if (!approvedRecommendationId) return;

  statusEl.textContent = "Approving recommendation again...";

  try {
    var data = await fetchJson(
      getAdminApiBase() + "/mwc-admin/reapprove-recommendations",
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          approved_recommendation_ids: [Number(approvedRecommendationId)]
        })
      }
    );

    if (!data.success) {
      statusEl.textContent = "Error approving recommendation again.";
      return;
    }

    statusEl.textContent =
      "Approved again " +
      Number(data.reapproved_count || 0) +
      " recommendation(s).";

    await loadApprovedRecommendations();
    await loadQueue({ preserveStatus: true });
  } catch (error) {
    statusEl.textContent =
      "Request failed while approving again: " +
      String(error.message || error);
  }
}

async function removeApprovedRecommendation(approvedRecommendationId) {
  if (!approvedRecommendationId) return;

  statusEl.textContent = "Removing approved recommendation...";

  try {
    var data = await fetchJson(
      getAdminApiBase() + "/mwc-admin/unapprove-recommendations",
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          approved_recommendation_ids: [Number(approvedRecommendationId)]
        })
      }
    );

    if (!data.success) {
      statusEl.textContent = "Error removing approved recommendation.";
      return;
    }

    statusEl.textContent =
      "Removed " +
      Number(data.unapproved_count || 0) +
      " approved recommendation(s).";

    if (selectedWatch) {
      selectedWatch.approved_count = Math.max(
        0,
        Number(selectedWatch.approved_count || 0) -
          Number(data.unapproved_count || 0)
      );

      selectedWatch.remaining_slots = Math.max(
        0,
        Number(selectedWatch.max_recommendations || 5) -
          Number(selectedWatch.approved_count || 0)
      );

      if (approvedCounterEl) {
        approvedCounterEl.textContent =
          "Approved " +
          selectedWatch.approved_count +
          " / " +
          selectedWatch.max_recommendations +
          " · Remaining slots: " +
          selectedWatch.remaining_slots;
      }

      if (nextRecommendationsButton) {
        nextRecommendationsButton.disabled = selectedWatch.remaining_slots <= 0;
      }
    }

    await loadApprovedRecommendations();
    await loadQueue({ preserveStatus: true });
  } catch (error) {
    statusEl.textContent =
      "Request failed while removing approved recommendation: " +
      String(error.message || error);
  }
}

async function saveRecommendationSettings() {
  if (!selectedWatch) {
    statusEl.textContent = "Select a watch first.";
    return;
  }

  if (!maxRecommendationsInput) {
    statusEl.textContent = "Max recommendations field not found.";
    return;
  }

  var maxRecommendations = Number(maxRecommendationsInput.value || 5);
  maxRecommendations = Math.min(Math.max(maxRecommendations, 1), 20);

  maxRecommendationsInput.value = maxRecommendations;

  statusEl.textContent = "Saving max recommendations...";

  try {
    var data = await fetchJson(
      getAdminApiBase() + "/mwc-admin/recommendation-settings",
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          user_watch_id: selectedWatch.user_watch_id,
          max_recommendations: maxRecommendations
        })
      }
    );

    if (!data.success) {
      statusEl.textContent = "Error saving max recommendations.";
      return;
    }

    selectedWatch.max_recommendations = Number(data.max_recommendations || maxRecommendations);
    selectedWatch.approved_count = Number(data.approved_count || selectedWatch.approved_count || 0);
    selectedWatch.remaining_slots = Number(data.remaining_slots || 0);

    if (approvedCounterEl) {
      approvedCounterEl.textContent =
        "Approved " +
        selectedWatch.approved_count +
        " / " +
        selectedWatch.max_recommendations +
        " · Remaining slots: " +
        selectedWatch.remaining_slots;
    }

    statusEl.textContent =
      "Saved max recommendations: " + selectedWatch.max_recommendations + ".";

    await loadQueue({ preserveStatus: true });
  } catch (error) {
    statusEl.textContent =
      "Request failed while saving max recommendations: " +
      String(error.message || error);
  }
}

async function approveSelectedCandidates() {
  var checkboxes = Array.from(
  document.querySelectorAll("[data-mwc-candidate-checkbox]:checked")
);

var candidateIds = checkboxes
  .map(function (checkbox) {
    return Number(checkbox.value);
  })
  .filter(Boolean);

if (!candidateIds.length) {
  statusEl.textContent = "Select at least one candidate.";
  return;
}

if (!selectedWatch) {
  statusEl.textContent =
    "The selected watch is no longer active. Please click the watch in the queue again.";
  return;
}

var approvedCount = Number(selectedWatch.approved_count || 0);
var maxRecommendations = Number(selectedWatch.max_recommendations || 5);
var remainingSlots = Math.max(0, maxRecommendations - approvedCount);

selectedWatch.remaining_slots = remainingSlots;

if (remainingSlots <= 0) {
  statusEl.textContent =
    "This watch has already reached the maximum number of approved recommendations.";
  return;
}

if (candidateIds.length > remainingSlots) {
  statusEl.textContent =
    "You selected " +
    candidateIds.length +
    " recommendation(s), but only " +
    remainingSlots +
    " slot(s) are still available. Select fewer items or increase the max.";
  return;
}

statusEl.textContent = "Approving selected recommendations...";

if (approveButton) {
  approveButton.disabled = true;
}

try {
    var data = await fetchJson(
      getAdminApiBase() + "/mwc-admin/approved-recommendations",
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          candidate_ids: candidateIds,
          approved_by: "theme_admin"
        })
      }
    );

    if (!data.success) {
      statusEl.textContent = "Error approving recommendations.";
      return;
    }

    statusEl.textContent =
      "Approved " +
      Number(data.approved_count || 0) +
      " recommendation(s). Skipped " +
      Number(data.skipped_count || 0) +
      ".";

    if (data.skipped && data.skipped.length) {
      statusEl.textContent +=
        " Reason: " +
        data.skipped
          .map(function (item) {
            return item.reason;
          })
          .filter(Boolean)
          .join(", ");
    }

    selectedWatch.approved_count =
      Number(selectedWatch.approved_count || 0) +
      Number(data.approved_count || 0);

    selectedWatch.remaining_slots = Math.max(
      0,
      Number(selectedWatch.max_recommendations || 5) -
        Number(selectedWatch.approved_count || 0)
    );

    if (approvedCounterEl) {
      approvedCounterEl.textContent =
        "Approved " +
        selectedWatch.approved_count +
        " / " +
        selectedWatch.max_recommendations +
        " · Remaining slots: " +
        selectedWatch.remaining_slots;
    }

if (selectedWatch.remaining_slots <= 0) {
  if (candidatesEl) {
    candidatesEl.innerHTML =
      "<div class='text-sm text-subdued'>This watch has reached the maximum number of approved recommendations.</div>";
  }

  if (approveButton) {
    approveButton.style.display = "none";
  }

  if (nextRecommendationsButton) {
    nextRecommendationsButton.disabled = true;
  }

  statusEl.textContent =
    "This watch is complete: approved " +
    selectedWatch.approved_count +
    " / " +
    selectedWatch.max_recommendations +
    ".";
} else {
  if (nextRecommendationsButton) {
    nextRecommendationsButton.disabled = false;
  }
}

    checkboxes.forEach(function (checkbox) {
      var card = checkbox.closest("[data-mwc-candidate-card]");
      if (card) {
        card.remove();
      }
    });

    if (!document.querySelector("[data-mwc-candidate-checkbox]")) {
      if (candidatesEl) {
        candidatesEl.innerHTML =
          "<div class='text-sm text-subdued'>No pending candidates shown. Click Next recommendations for more.</div>";
      }

      if (approveButton) {
        approveButton.style.display = "none";
      }
    }
    await loadApprovedRecommendations();
    await loadQueue({ preserveStatus: true });
  } catch (error) {
  statusEl.textContent =
    "Request failed while approving recommendations: " +
    String(error.message || error);
} finally {
  if (approveButton) {
    approveButton.disabled = false;
  }
}
}

    if (refreshQueueButton) {
  refreshQueueButton.addEventListener("click", loadQueue);
}

if (queueFilterEl) {
  queueFilterEl.addEventListener("change", function () {
    renderQueue(getFilteredQueueItems());

    if (statusEl) {
      statusEl.textContent =
        "Showing " + getFilteredQueueItems().length + " watch(es).";
    }
  });
}

if (onlyWithPhotoEl) {
  onlyWithPhotoEl.addEventListener("change", function () {
    renderQueue(getFilteredQueueItems());

    if (statusEl) {
      statusEl.textContent =
        "Showing " + getFilteredQueueItems().length + " watch(es).";
    }
  });
}

if (onlyWithLugWidthEl) {
  onlyWithLugWidthEl.addEventListener("change", function () {
    renderQueue(getFilteredQueueItems());

    if (statusEl) {
      statusEl.textContent =
        "Showing " + getFilteredQueueItems().length + " watch(es).";
    }
  });
}


if (nextRecommendationsButton) {
  nextRecommendationsButton.addEventListener("click", loadNextRecommendations);
}

if (approveButton) {
  approveButton.addEventListener("click", approveSelectedCandidates);
}

if (candidatesEl) {
  candidatesEl.addEventListener("click", function (event) {
    var pageButton = event.target.closest("[data-mwc-candidate-page]");

    if (pageButton) {
      event.preventDefault();
      event.stopPropagation();
      loadCandidatePage(Number(pageButton.getAttribute("data-mwc-candidate-page") || 1));
      return;
    }

    var button = event.target.closest("[data-mwc-candidate-tag-info]");

    if (!button) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    loadCandidateTagInfo(button);
  });
}

if (saveSettingsButton) {
  saveSettingsButton.addEventListener("click", saveRecommendationSettings);
}

adminViewButtons.forEach(function (button) {
  button.addEventListener("click", function () {
    setAdminView(button.getAttribute("data-mwc-admin-view"));
  });
});

if (refreshScoringRulesButton) {
  refreshScoringRulesButton.addEventListener("click", function () {
    loadScoringConfigOptions().then(function () {
      loadScoringRules();
    });
  });
}


if (newWatchAttributeInput) {
  newWatchAttributeInput.addEventListener("change", function () {
    updateAddScoringRuleWatchValueDropdown();
  });
}

if (newWatchValueInput) {
  newWatchValueInput.addEventListener("change", validateAddScoringRuleWatchValue);
  newWatchValueInput.addEventListener("blur", validateAddScoringRuleWatchValue);
}

if (newProductAttributeInput) {
  newProductAttributeInput.addEventListener("change", function () {
    updateAddScoringRuleProductValueDropdown();
  });
}

if (newProductValueInput) {
  newProductValueInput.addEventListener("change", validateAddScoringRuleProductValue);
  newProductValueInput.addEventListener("blur", validateAddScoringRuleProductValue);
}

if (addScoringRuleButton) {
  addScoringRuleButton.addEventListener("click", async function () {
    if (addScoringRuleButton.disabled) {
      return;
    }
    var watchAttribute = newWatchAttributeInput
      ? normalizeRuleKey(newWatchAttributeInput.value)
      : "";

    var payload = {
      rule_group: watchAttribute,
      watch_attribute: watchAttribute,
      product_attribute: newProductAttributeInput ? normalizeRuleKey(newProductAttributeInput.value) : "",
      watch_value: newWatchValueInput ? newWatchValueInput.value.trim() : "",
      product_value: newProductValueInput ? newProductValueInput.value.trim() : "",
      points: newPointsInput ? Number(newPointsInput.value) : NaN,
      reason_template: newReasonInput ? newReasonInput.value.trim() : "",
      active: newActiveInput ? newActiveInput.value === "1" : true
    };

    if (!payload.rule_group || !payload.watch_attribute || !payload.watch_value || !payload.product_attribute || !payload.product_value || !Number.isFinite(payload.points)) {
      if (scoringStatusEl) {
        scoringStatusEl.textContent =
          "Please fill watch_attribute, watch_value, product_attribute, product_value and points.";
      }

      return;
    }

    if (!isConfiguredValue("watch_attribute", payload.watch_attribute, payload.watch_value)) {
      if (scoringStatusEl) {
        scoringStatusEl.textContent =
          "Choose an existing configured watch value for " + payload.watch_attribute + ".";
      }

      if (newWatchValueInput) {
        newWatchValueInput.value = "";
        newWatchValueInput.focus();
      }

      return;
    }

    if (!isConfiguredValue("product_attribute", payload.product_attribute, payload.product_value)) {
      if (scoringStatusEl) {
        scoringStatusEl.textContent =
          "Choose an existing configured product value for " + payload.product_attribute + ".";
      }

      if (newProductValueInput) {
        newProductValueInput.value = "";
        newProductValueInput.focus();
      }

      return;
    }

    addScoringRuleButton.disabled = true;
    addScoringRuleButton.textContent = "Adding...";

    if (scoringStatusEl) {
      scoringStatusEl.textContent = "";
    }

    try {
      var response = await fetch(
        getAdminApiBase() + "/mwc-admin/scoring-rules",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(payload)
        }
      );

      var data = null;

      try {
        data = await response.json();
      } catch (jsonError) {
        data = {
          success: false,
          error: "Could not read server response"
        };
      }

      if (!response.ok || !data.success) {
        throw new Error(data.error || "Could not add scoring rule");
      }

      addScoringRuleButton.textContent = "Added";

      if (scoringStatusEl) {
        scoringStatusEl.textContent = "Scoring rule added.";
      }

      resetAddScoringRuleForm();
      await loadScoringRules();

      window.setTimeout(function () {
        addScoringRuleButton.disabled = false;
        addScoringRuleButton.textContent = "Add rule";

        if (scoringStatusEl) {
          scoringStatusEl.textContent = "";
        }
      }, 800);
    } catch (error) {
      console.error("Failed to add scoring rule:", error);

      addScoringRuleButton.disabled = false;
      addScoringRuleButton.textContent = "Add rule";

      if (scoringStatusEl) {
        scoringStatusEl.textContent =
          "Could not add scoring rule: " + String(error.message || error);
      }
    }
  });
}


if (scoringRulesEl) {
  scoringRulesEl.addEventListener("click", async function (event) {
    var deleteButton = event.target.closest("[data-mwc-delete-scoring-rule]");

    if (deleteButton) {
      if (deleteButton.disabled) {
        return;
      }

      var deleteRow = deleteButton.closest("[data-mwc-scoring-rule-row]");

      if (!deleteRow) {
        return;
      }

      var deleteId = deleteButton.getAttribute("data-rule-id");

      if (!window.confirm("Delete this scoring rule from the database?")) {
        return;
      }

      deleteButton.disabled = true;
      deleteButton.textContent = "Deleting...";

      if (scoringStatusEl) {
        scoringStatusEl.textContent = "";
      }

      try {
        var deleteData = await fetchJson(
          getAdminApiBase() + "/mwc-admin/scoring-rules/" + encodeURIComponent(deleteId),
          {
            method: "DELETE",
            credentials: "include"
          }
        );

        if (!deleteData.success) {
          throw new Error(deleteData.error || "Could not delete scoring rule");
        }

        if (scoringStatusEl) {
          scoringStatusEl.textContent = "Scoring rule deleted.";
        }

        await loadScoringRules();
      } catch (error) {
        console.error("Failed to delete scoring rule:", error);

        deleteButton.disabled = false;
        deleteButton.textContent = "Delete";

        if (scoringStatusEl) {
          scoringStatusEl.textContent =
            "Could not delete scoring rule: " + String(error.message || error);
        }
      }

      return;
    }

    var button = event.target.closest("[data-mwc-save-scoring-rule]");

if (!button) {
  return;
}

if (button.disabled) {
  return;
}

    var row = button.closest("[data-mwc-scoring-rule-row]");

    if (!row) {
      return;
    }

    var id = button.getAttribute("data-rule-id");
    var pointsInput = row.querySelector("[data-mwc-scoring-points]");
    var activeInput = row.querySelector("[data-mwc-scoring-active]");
    var reasonInput = row.querySelector("[data-mwc-scoring-reason]");

    var originalText = "Save";

    button.disabled = true;
    button.textContent = "Saving...";

    if (scoringStatusEl) {
      scoringStatusEl.textContent = "";
    }

    try {
      var data = await fetchJson(
        getAdminApiBase() + "/mwc-admin/scoring-rules/" + encodeURIComponent(id),
        {
          method: "PATCH",
          credentials: "include",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            points: Number(pointsInput.value),
            active: activeInput.value === "1",
            reason_template: reasonInput.value
          })
        }
      );

      if (!data.success) {
        throw new Error(data.error || "Could not save scoring rule");
      }

      button.textContent = "Saved";

      if (scoringStatusEl) {
        scoringStatusEl.textContent = "Scoring rule saved.";
      }

      window.setTimeout(function () {
        button.disabled = false;
        button.textContent = originalText;

        if (scoringStatusEl) {
          scoringStatusEl.textContent = "";
        }
      }, 800);
    } catch (error) {
      console.error("Failed to save scoring rule:", error);

      button.disabled = false;
      button.textContent = originalText;

      if (scoringStatusEl) {
        scoringStatusEl.textContent =
          "Could not save scoring rule: " + String(error.message || error);
      }
    }
  });
}


setAdminView("review");
loadQueue();

  });
})();
